<template>
  <div class="c-app flex-row align-items-center amsys-header">
    <CWrapper>
      <CHeader fixed with-subheader light style="position: fixed;">
        <CToggler
          in-header
          class="ml-3 d-lg-none"
          @click="$store.commit('toggleSidebarMobile')"
        />
        <CToggler
          in-header
          class="ml-3 d-md-down-none"
          @click="$store.commit('toggleSidebarDesktop')"
        />
        <CHeaderBrand class="d-lg-none">
          <h3>
            <b> <font color="Green">PROFILE</font></b>
          </h3>
        </CHeaderBrand>
        <CHeaderNav class="d-md-down-none mr-auto">
          <CHeaderNavItem class="px-3">
            <h3>
              <b> <font color="Green">PROFILE</font></b>
            </h3>
          </CHeaderNavItem>
        </CHeaderNav>
      </CHeader>
      <div class="c-body" style="margin-top: 3rem;">
        <main class="c-main">
          <div style="margin-bottom: 17px;">
            <CRow class="justify-content-center">
              <CAlert color="primary" v-if="notif" id="notifError"> </CAlert>
            </CRow>
            <CRow class="justify-content-center">
              <CRow>
                <CCol
                  sm="6"
                  md="2"
                  style="width:50%; padding:4px; margin-bottom: -15px !important;"
                >
                  <img
                    src="img/no-photo.jpg"
                    class="c-avatar-img "
                    style="width: 220px;height: 194px;padding-left:10px; padding-right:10px;"
                  />
                </CCol>
              </CRow>
            </CRow>
            <br />
            <CRow class="justify-content-center">
              <CRow>
                <h4>
                  <b>{{ this.User }} / {{ this.Role }} </b>
                </h4>
              </CRow>
            </CRow>
            <CRow class="justify-content-center">
              <CRow>
                <button
                  class="btn btn-pill btn-block btn-info"
                  @click="showModalChangePassword()"
                  type="button"
                >
                  Change Password
                </button>
              </CRow>
            </CRow>
            <br />
            <br />
            <CRow class="justify-content-center">
              <CAlert color="primary" v-if="notif" id="notifError"> </CAlert>
            </CRow>
            <CModal
              size="sm"
              :show.sync="modalChangePassword"
              color="info"
              style="font-size: 15px;"
            >
              <font style="font-size:15px; width: 80%;"
                ><b>New Password</b></font
              >
              <br />
              <br />
              <CInput
                placeholder="Old Password"
                autocomplete="curent-password"
                type="password"
                v-model="oldPassword"
              >
              </CInput>
              <br />
              <CInput
                placeholder="New Password"
                autocomplete="curent-password"
                type="password"
                v-model="password"
              >
              </CInput>
              <CInput
                placeholder="Retype Password"
                type="password"
                autocomplete="curent-password"
                v-model="Newpassword"
              >
              </CInput>
              <template #footer>
                <CButton
                  @click="modalChangePassword = false"
                  color="secondary"
                  style="font-size: 15px;"
                  >Close</CButton
                >
                <CButton
                  @click="actionModalCP()"
                  style="font-size: 15px;"
                  class="btn btn-info"
                >
                  OK
                </CButton>
              </template>
            </CModal>
          </div>
        </main>
      </div>
    </CWrapper>
  </div>
</template>
<script>
import vue from "vue";
import axios from "axios";
import "@babel/polyfill";
import router from "vue-router";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import CryptoJS from "crypto-js";

export default {
  name: "Profile",
  components: {},
  data() {
    return {
      results: [],
      Role: "",
      User: "",
      showError: false,
      loading: false,
      notif: false,
      modalChangePassword: false,
      password: "",
      Newpassword: "",
      notif: false,
      oldPassword: "",
      urlServer: "",
    };
  },
  methods: {
    showModalChangePassword() {
      this.password = "";
      this.Newpassword = "";
      this.oldPassword = "";
      this.modalChangePassword = true;
    },
    async actionModalCP() {
      if (
        this.password != "" &&
        this.Newpassword != "" &&
        this.oldPassword != ""
      ) {
        if (this.password != this.Newpassword) {
          vue.$toast.open({
            message: "Password & Retype Password must equal !",
            type: "error",
            position: "bottom",
          });
        } else if (this.oldPassword != this.password) {
          const form = new FormData();
          let data = localStorage.token;
          form.append("oldPass", this.oldPassword);
          form.append("newPass", this.password);
          let sendData = JSON.stringify(Object.fromEntries(form));
          await axios
            .post(`${this.urlServer}/Api/General/ChangePassword/`, sendData, {
              headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers":
                  "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
                "content-type": "application/json",
                Authorization: "Bearer " + data,
              },
            })
            .then((res) => {
              if (res.data != "FAILED") {
                console.log(res);
                vue.$toast.open({
                  message: "Password has been updated",
                  type: "success",
                  position: "bottom",
                });
                this.modalChangePassword = false;
              } else {
                console.log(res);
                vue.$toast.open({
                  message: "Password change failed",
                  type: "error",
                  position: "bottom",
                });
              }
            })
            .catch((error) => {
              vue.$toast.open({
                message: error,
                type: "error",
                position: "bottom",
              });
            });
        } else {
          vue.$toast.open({
            message: "Old password must not equal new password",
            type: "error",
            position: "bottom",
          });
        }
      } else {
        vue.$toast.open({
          message: "Password not null !",
          type: "error",
          position: "bottom",
        });
      }
    },
  },
  beforeMount() {
    console.log(localStorage.token);
    let data = localStorage.token;
    const stringToProtect = "Amsys_2@2021";
    let url = CryptoJS.AES.decrypt(localStorage.url, stringToProtect);
    this.urlServer = url.toString(CryptoJS.enc.Utf8);
    if (typeof data == "undefined") {
      this.$router.push({ path: "/logout" });
    } else {
      this.loading = true;
      axios
        .get(`${this.urlServer}/Api/Values/GetUserInfo/`, {
          headers: {
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          this.Role = res.data[0].Role;
          this.User = res.data[0].User;
        })
        .catch((error) => {
          let err = error.toString();
          if (err.toString().match(/^.*undefined.*$/)) {
            Vue.$toast.open({
              message: "Sorry, Your token has expired!",
              type: "warning",
              position: "bottom",
            });
            this.$router.push({ path: "/logout" });
          } else {
            Vue.$toast.open({
              message: error,
              type: "error",
              position: "bottom",
            });
          }
        });
    }
  },
};
</script>
